module.exports = __webpack_public_path__ + "static/media/test.6ea2be69.jpeg";